import React from 'react';
import { Container } from './styles';
import { Icon } from '@gerdau/hefesto/Icon';
import { Button } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { ELoyaltyRoutes } from '../../../loyalty.routes';
import { ERoutes } from '../../../../../routes';

const NotEnoughPoints: React.FC = () => {
  const history = useHistory();
  return (
    <Container>
      <Icon option="DollarSign" variant="primary" size="full" />
      <div className="text">
        <p className="subtitle">
          Você ainda não tem pontos suficientes para resgatar prêmios.
        </p>
        <p className="subtitle">Que tal simular quantos pontos faltam?</p>
      </div>
      <Button
        onClick={() => {
          history.push(`${ERoutes.LOYALTY}${ELoyaltyRoutes.LOYALTY_SIMULATOR}`);
        }}
        name="simulator"
      >
        Ir para o Simulador
      </Button>
    </Container>
  );
};

export default NotEnoughPoints;
